module.exports = __webpack_public_path__ + "img/retailer-spotify.8499c8e5.svg";